
define('text!templates/remove_reputation.html',[],function () { return '<span class="removeReputation" data-from="<%=from%>" data-to="<%=to%>" data-pid="<%=postId%>">&nbsp;</span>';});

